<template>
  <Modal title="Cargar Puntos" @close="emitClose">
    <div v-if="errors.length">
      <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
        <div class="mt-3 col-span-12 sm:col-span-12">
          <div
            class="bg-red-800 border border-red-600 rounded p-3 text-white"
            role="alert"
            v-for="error in errors"
            :key="`error-${error}`"
          >
            <div
              v-for="singleError in error"
              :key="`singleError-${singleError}`"
            >
              - {{ singleError }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <form
      @submit.prevent="createActivity"
      class="p-5 grid grid-cols-12 gap-4 row-gap-3"
    >
      <div class="mt-3 col-span-12">
        <label
          >Archivo: (
          <a
            class="text-blue-500 underline"
            href="/v1/files/formats/upload-users-points-format.xlsx"
            >Descargar formato</a
          >
          )
        </label>
        <input type="file" class="hidden" id="file" @change="onFileChange" />
        <div class="flex flex-col mt-2 my-auto w-full">
          <input
            type="text"
            class="input w-full border"
            v-model="pointsUploader.fileName"
            required
            disabled
            v-if="pointsUploader.file"
          />
          <label for="file" class="button bg-theme-10 text-white button-sm">
            <i class="fa fa-plus"></i> Cargar Archivo
          </label>
        </div>
      </div>

      <div class="mt-3 col-span-12">
        <label>Datos de las columnas:</label>
        <div class="input w-full border mt-2">
          Evento: nombre del evento <br />
          Correo usuario: correo electrónico del usuario <br />
          Puntos: Numero de puntos (Numero entero, sin simbolos) <br />
          Tipo: 1 para Actividades 2 para Custom <br />
          Mes: Numero del mes (1 a 12) <br />
          Año: Numero del año <br />
        </div>
      </div>

      <div class="col-span-12 px-5 py-3 text-right border-t border-gray-200">
        <button
          type="button"
          data-dismiss="modal"
          class="button border text-gray-700 mr-1"
          @click="emitClose"
        >
          Cancelar
        </button>
        <button type="submit" class="button bg-theme-1 text-white" id="edit">
          Cargar Puntos
        </button>
      </div>
    </form>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'
import axios from '@/services/axios'
import Modal from '@/components/assets/Modal/Modal'

export default {
  data() {
    return {
      activity: {},
      loadImage: false,
      pointsUploader: {
        file: null,
        fileName: '',
      },
      errors: [],
    }
  },
  created() {},
  methods: {
    async createActivity() {
      this.errors = []
      this.loading = true

      try {
        const formData = new FormData()

        Object.entries(this.pointsUploader).forEach(([key, value]) => {
          console.log(key, value)
          formData.append(key, value)
        })

        await axios.post('/point', formData)

        window.$toast.info('Puntos cargados correctamente')

        this.$emit('upload')
      } catch (error) {
        console.log({ error })
        this.errors = error.response.data.errors
        console.log(this.errors)
      } finally {
        this.loading = false
      }
    },
    emitClose() {
      this.$emit('close')
    },
    ...mapActions(['store']),
    onFileChange(e) {
      this.loadImage = true
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.pointsUploader.file = e.target.files[0]
      this.pointsUploader.fileName = e.target.files[0].name
    },
  },
  components: {
    Modal,
  },
}
</script>



// WEBPACK FOOTER //
// ModalLoadPoints.vue?7f202b20